import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { Company } from '../models/company';
import { environment } from '../../environments/environment';
import { User } from '../models/user';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  constructor(private http: HttpClient) { }

  private apiUrl = `${environment.apiUrl}`;
  private url: string = this.apiUrl + 'api/admin/companies'; 

  createCompany(company: Company): Observable<Company>{
    return this.http.post<Company>(this.url, company);
  }
  
  updateCompany(id: string,company: Company): Observable<any>{
    return this.http.put<any[]>(`${this.url}/${id}`,company);
  }

  updateAdminCompany(id: string,company: Company): Observable<any>{
    return this.http.put<any[]>(`${this.url}/updateAdmin/${id}`,company);
  }
  
  updateAdminCompanyLogo(id: string, file: File): Observable<any> {
    const formData = new FormData();
    formData.append('logo', file);
    return this.http.post(`${this.url}/updateAdmin/${id}/logo`, formData);
  }

  /*deleteCompany(id: string): Observable<any>{
    return this.http.delete<any[]>(`${this.url}/delete/${id}`);
  }*/

  findAllPageableCompany(page: number, pageSize: number): Observable<any> {
    return this.http.get<any[]>(`${this.url}/page/${page}/${pageSize}`);
  }
  
  findCompanyById(id: string): Observable<Company> {
    return this.http.get<Company>(`${this.url}/${id}`);
  }
  getCompanyLogo(id: string) {
    return this.http.get(
      `${this.url}/${id}/logo`,
      { responseType: 'blob' }
    );
  }
  findUsersOfCompany(id: string): Observable<any> {
    return this.http.get<any[]>(`${this.url}/usersOfCompany/${id}`);
  }
  createUserCompany(id: string, user: User): Observable<User>{
    return this.http.post<User>(`${this.url}/createUserForCompany/${id}`, user);
  }
  
}